/**
 * Copyright Mántum All Rights Reserved.
 */
import Body from './body';
import Page from './page';
import useOpen from '../../hooks/useOpen';

import type { Kanela, Action, Mode } from '@mantum/kanela';

type PropTypes = {
    action?: Action;
    description?: string;
    title?: {
        action?: {
            title: string;
            enabled: boolean;
        };
        page?: string;
        sidebar?: string;
    };
    mode?: Mode;
    children?: React.ReactElement;
    content?: React.ReactElement;
    formRef?: React.RefObject<Kanela>;
    onClear?: () => void;
    onSuccessSubmit?: (refresh?: string[]) => void;
    open?: boolean;
};

export default function Index(props: PropTypes) {
    // prettier-ignore
    const {
        open = false
    } = props

    // prettier-ignore
    const { 
        onClose,
        onOpen,
        value: isOpen
    } = useOpen(open);

    const onClear = () => {
        onClose();
        if (props.onClear) {
            props.onClear();
        }
    };

    return (
        <>
            <Page
                action={props.title?.action?.title}
                description={props.description}
                enabled={props.title?.action?.enabled}
                onClick={onOpen}
                title={props.title?.page}
            >
                {props.content}
            </Page>
            <Body
                action={props.action}
                formRef={props.formRef}
                onClear={onClear}
                onClose={onClose}
                onSuccessSubmit={props.onSuccessSubmit}
                open={isOpen}
                title={props.title?.sidebar}
            >
                {props.children}
            </Body>
        </>
    );
}
